import {Divider, Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;

const CustomerNeeds = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX'], marginTop: '3%'}}>Consumer Needs</Paragraph>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '70%', background: 'inherit'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-customer-needa.jpg'/>
          <p>Img 4. Living with aging in Mexico</p>
        </Content>
        <Text className='BaseText2' style={{marginTop: '2%'}}>After having different sessions and activities with our consumers, we made an empathy map. <b>The empathy map is a tool to deconstruct customers’ feelings, experiences, and goals to identify their needs </b> according to the 7 empathy map questions. Through literature research and by interacting with our stakeholders we were able to identify our customer needs shown in the Image 4. (Check Human Practices Section.)</Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '80%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-4.png'/>
          <p>Img 5. iMoAge Empathy Map. Through different activities done in the Human Practices Section we were  able to deconstruct customers’ feelings, experiences, and goals to identify their needs according to 7 guiding questions</p>
        </Content>
        <Text className='BaseText2' style={{marginTop: '2%'}}>We also made a <b>value proposition canvas in order to identify how our product can relieve pain and create gains for our customers</b> (Image 5) in order to improve and validate if iMoAge will cover our customers needs.</Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '80%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-5.png'/>
          <p>Img 6. iMoAge Value Propostion Canvas. Through different activities done in the Human Practices Section we were  able to ensure that our  product is positioned around what the customer values and needs.</p>
        </Content>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default CustomerNeeds;
